import { render, staticRenderFns } from "./CouponStatics.vue?vue&type=template&id=9e319ea0&scoped=true"
import script from "./CouponStatics.vue?vue&type=script&lang=js"
export * from "./CouponStatics.vue?vue&type=script&lang=js"
import style0 from "./CouponStatics.vue?vue&type=style&index=0&id=9e319ea0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e319ea0",
  null
  
)

export default component.exports